import dayjs from "dayjs";

export function checkYearAccess(createdAt) {
  return dayjs(createdAt).add(1, "year").isBefore(dayjs());
}

// Пожизненный доступ (ТЗ #2): у новых покупок accessDuration = -1 — не истекают.
// Старые игры (accessDuration NULL) живут по прежнему годовому правилу.
export function isGameAccessExpired(game) {
  if (!game) return false;
  if (game.accessDuration === -1) return false;
  return checkYearAccess(game.createdAt);
}
